const Dropdown = () => ({
  isOpen: false,

  close(ref) {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;

    if (ref) {
      ref.focus();
    }
  },

  toggle() {
    if (this.isOpen) {
      return this.close();
    }

    this.$refs.button.focus();

    this.isOpen = true;
  },

  dropdown: {
    'x-id': "['dropdown']",

    ['x-on:focusin.window']($event) {
      if (!this.$refs.panel.contains($event.target)) {
        this.close();
      }
    },

    ['x-on:keydown.escape.prevent.stop']() {
      this.close(this.$refs.button);
    },
  },

  dropdownButton: {
    [':aria-expanded']() {
      return this.isOpen;
    },

    [':aria-controls']() {
      return this.$id('dropdown');
    },

    ['x-on:click']() {
      this.toggle();
    },

    ['x-ref']: 'button',
  },

  dropdownPanel: {
    [':id']() {
      return this.$id('dropdown');
    },

    ['x-cloak']: true,

    ['x-ref']: 'panel',

    ['x-on:click.outside']() {
      this.close(this.$refs.button);
    },

    ['x-show']() {
      return this.isOpen;
    },

    ['x-transition:enter']: 'transition ease-out duration-100',

    ['x-transition:enter-start']: 'transform opacity-0 scale-95',

    ['x-transition:enter-end']: 'transform opacity-100 scale-100',

    ['x-transition:leave']: 'transition ease-in duration-75',

    ['x-transition:leave-start']: 'transform opacity-100 scale-100',

    ['x-transition:leave-end']: 'transform opacity-0 scale-95',
  },
});

export default Dropdown;
